import { http } from './base/http';

export const LoginLinkAPIs = {
    async sendLoginLink(email: string): Promise<Record<string, unknown>> {
        return await http.post('/auth/login_link', { email });
    },
};
